
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "NavigationTab",
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    icon: {
      type: Function,
    },
    count: {
      type: Number as PropType<number>,
    },
    href: {
      type: String as PropType<string>,
    },
    current: {
      type: Boolean as PropType<boolean>,
    },
  },
});
